module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAGAgMAAADMNjS4AAAAAXNSR0IB2cksfwAAAAlQTFRFAAAA/6+9/7C9lUWJaAAAAAN0Uk5TAID/7PezGAAAACFJREFUeJxjYJBaBQErGRiyoMwlDIxQ1qoJDGwwpgN2pQBM4iGylmB15gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/2@2x.png
// module id = 19wS
// module chunks = 1